export const pxToRem = (value: number) => `${value * 0.0625}rem`;
